import { render, staticRenderFns } from "./barra-lateral.vue?vue&type=template&id=44a952e1&scoped=true&"
import script from "./barra-lateral.vue?vue&type=script&lang=ts&"
export * from "./barra-lateral.vue?vue&type=script&lang=ts&"
import style0 from "./barra-lateral.vue?vue&type=style&index=0&id=44a952e1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a952e1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow,VSpacer})
